import { FlexBox } from '@ardoq/layout';
import { WithPopover, WrapperWithEllipsisOverflow } from '@ardoq/popovers';

export const IdentifierWithPopover = ({
  identifierString,
}: {
  identifierString: string | undefined;
}) => {
  if (!identifierString) {
    return null;
  }
  return (
    <FlexBox maxWidth="50%">
      <WithPopover
        content={() => <FlexBox maxWidth="500px">{identifierString}</FlexBox>}
      >
        <WrapperWithEllipsisOverflow $lineClamp={4}>
          {identifierString}
        </WrapperWithEllipsisOverflow>
      </WithPopover>
    </FlexBox>
  );
};
